import { create } from 'zustand'

export const useLoaderStore = create<any>((set:any) => ({
    is_loader: false,
    setIs_Loader_True: () => set(() => ({ is_loader: true })),
    setIs_Loader_False: () => set(() => ({ is_loader: false }))
}));